import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading, WideCardFilter, Pagination } from '../Main'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { currencyFormat, prettyUrl, formatDecimal } from '../../utility/Helpers'
import { confirmationAlert } from '../../utility/SweetAlert'
import { INVOICE_V2 } from '../../constant/global/config'
import moment from 'moment'
import InteractorShippingHeaderCancel from '../../interactors/transaction/shipping/InteractorShippingHeaderCancel'
import InteractorShippingHeaderApproval from '../../interactors/transaction/shipping/InteractorShippingHeaderApproval'
import { defaultValueDownloadCSV } from '../../constant/global/validation'

const WideCardConfirmationShipping = (data) => {
  const { loading, datacard, payload, download, setDownload, getDataConfirmShipping, loadingCSV } =
    data

  const { t } = useTranslation()
  const { account } = useSelector((state) => state.account)
  const { shippingHeaderApproval } = InteractorShippingHeaderApproval()
  const { shippingHeaderCancel } = InteractorShippingHeaderCancel()
  const [payloadFilter, setPayloadFilter] = useState(payload)

  const filter = {
    text_search: true,
    status: {
      multiple: true,
      options: [
        { value: 'SHIPPED', label: t(`status.bill.SHIPPED`) },
        { value: 'DELIVERED', label: t(`status.bill.DELIVERED`) },
        { value: 'CANCELLED', label: t(`status.bill.CANCELLED`) },
        { value: 'CORRECTION', label: t(`status.bill.CORRECTION`) },
      ],
    },
    download: download,
  }

  const handleFilter = (row) => {
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.text_search = row.keywords.text_search
    objPayload.keywords.status = row.keywords.status
    data.handleFilter(objPayload)
    setDownload(defaultValueDownloadCSV)
    setPayloadFilter(objPayload)
  }

  const handlePageChange = (page) => {
    let objPayload = { ...payloadFilter }
    objPayload.page = page
    data.handleFilter(objPayload)
    setDownload(defaultValueDownloadCSV)
    setPayloadFilter(objPayload)
  }

  const handleLimitChange = (limit) => {
    let objPayload = { ...payloadFilter }
    objPayload.limit = parseInt(limit)
    data.handleFilter(objPayload)
    setDownload(defaultValueDownloadCSV)
    setPayloadFilter(objPayload)
  }

  // CARD AREA
  const CardHeader = (data) => {
    const row = data.data
    return (
      <>
        <div className="row">
          <div className="col-8 mt-2">
            <div className="d-flex align-items-center gap-2">
              <i className="fas fa-truck fa-2x"></i>
              <div className="px-3 py-2">
                <small>{t(`title.shipping_number`)}</small> <br />
                <strong>{row.shipping_number !== '' ? row.shipping_number : '-'}</strong>
              </div>
            </div>
          </div>
          <div className="col-4 mt-1 d-flex justify-content-end">
            <span className="d-inline-block p-2">
              <small>{t('title.bill_status')}: </small> <br />
              <span className={`text-gray font-weight-bold text-gray`}>
                {row?.bill_status
                  ? t(`status.shipping_bill_status.${row.bill_status.toLowerCase()}`)
                  : '-'}
              </span>
            </span>
          </div>
        </div>
        <hr className="m-0" />
      </>
    )
  }

  const CardBody = (data) => {
    const row = data.data
    const items = row.shipping_items.sort((a, b) => a.created_date - b.created_date)
    const [expanded, setExpanded] = useState(false)

    const subtotal = items?.reduce(
      (acc, item) => acc + item?.product_quantity * item?.product_price_item,
      0,
    )

    const trimDecimal = (num, decimalPlaces = 2) => {
      if (typeof num !== 'number' || isNaN(num)) {
        return NaN
      }

      const decimalPart = num % 1 !== 0 ? num.toString().split('.')[1] : null
      if (!decimalPart || decimalPart.length <= decimalPlaces) {
        return num
      }

      return Math.round((parseFloat(num.toFixed(10)) + Number.EPSILON) * 100) / 100
    }

    const toggleExpanded = () => {
      setExpanded(!expanded)
    }

    const renderItems = () => {
      const itemsToRender = expanded ? items : items.slice(0, 3)
      return (
        itemsToRender?.length > 0 &&
        itemsToRender.map((item, key) => {
          return (
            item && (
              <tr key={key}>
                <td className="col d-flex flex-column flex-md-row">
                  <div className="col-8 col-md-3 min-width-60 px-0">
                    <Link
                      to={`/product/detail/${prettyUrl(item?.product_title) + '/' + item?.uid}`}
                    >
                      <img src={item?.product_thumbnail} className="img-fluid" alt="" />
                    </Link>
                  </div>
                  <div className="col-12 col-md-9 px-0 px-md-3">
                    <Link
                      to={`/product/detail/${prettyUrl(item?.product_title) + '/' + item?.uid}`}
                      className="text-black product-title-ellipsis"
                      title={item?.product_title}
                    >
                      <div
                        className="badge bg-primary text-white rounded-pill px-2 py-1 fw-bold"
                        style={{ fontSize: '9px' }}
                      >
                        {t(`title.${item?.product_type.toLowerCase()}`)}
                      </div>
                      <div>
                        <strong>{item?.product_title}</strong>
                      </div>
                    </Link>
                  </div>
                </td>
                <td>
                  {currencyFormat(item?.product_price_item, item?.product_price_currency)} /{' '}
                  <small>{item?.product_unit_type}</small>
                </td>
                <td>{formatDecimal(item?.product_quantity, 2)}</td>

                <td>
                  <div>
                    {currencyFormat(
                      item?.product_price_item * item?.product_quantity,
                      item?.product_price_currency,
                    )}
                  </div>
                  {/* <div>
                    {item?.product_type === 'SERVICE' && (
                      <small style={{ fontSize: '90% !important' }}>
                        <i>
                          {t('title.ppn_amount')}:{' '}
                          {currencyFormat(item?.product_price_ppn, item?.product_price_currency)}
                        </i>
                      </small>
                    )}
                  </div> */}
                </td>
              </tr>
            )
          )
        })
      )
    }

    return (
      <>
        <InformationTransaction data={row} />
        <table className="table table-responsive table-borderless">
          <thead>
            <tr>
              <th className="col-5">{t('title.product.title')}</th>
              <th className="col-2">{t('title.product.price')}</th>
              <th className="col-2">{t('title.product.qty')}</th>
              <th className="col-3">{t('title.product.price_total')}</th>
              <th className=""></th>
            </tr>
          </thead>
          <tbody>{renderItems()}</tbody>
        </table>
        {items.length > 3 && (
          <div className="text-center">
            <button
              onClick={toggleExpanded}
              className="d-inline btn btn-xs m-2 font-size-10"
              style={{ background: '#396AFC' }}
            >
              {expanded ? t('button.show_less') : t('button.show_more')}
            </button>
          </div>
        )}
        <hr className="m-0" />
        <div className="row mb-2">
          <div className="col-xs-12 col-md-6">
            <table className="table table-borderless m-2">
              <tbody>
                <tr>
                  <td className="col-xs-6 p-0">{t('title.subtotal_product')}</td>
                  <td className="p-0">
                    <div className="font-weight-bold">
                      {items
                        ? currencyFormat(trimDecimal(subtotal), items[0]?.product_price_currency)
                        : currencyFormat(trimDecimal(subtotal), 'IDR')}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
  }
  /*
  const AlertBill = (data) => {
    const row = data.row
    let alert = ''
    if (
      ['PROCESSED', 'SHIPPED', 'DELIVERED', 'COMPLETED'].includes(row.status) &&
      row.payment_type === 'TOP' &&
      row.payment_status === 'UNPAID'
    ) {
      const today = formatDate(new Date(), 'YYYY-MM-DD')
      const term_date = formatDate(row.payment_term_date, 'YYYY-MM-DD')
      let coming_soon = new Date(row.payment_term_date)
      coming_soon.setDate(coming_soon.getDate() - 3)
      const coming_date = formatDate(coming_soon, 'YYYY-MM-DD')
      if (today === term_date) {
        alert = (
          <div className="alert alert-danger col-12">
            {`${t('alert.due_date_today')} ${t('title.please_pay_bill')}`}
          </div>
        )
      } else if (today > term_date) {
        var passed_date = new Date().getTime() - new Date(row.payment_term_date).getTime()
        passed_date = passed_date / (1000 * 3600 * 24)
        alert = (
          <div className="alert alert-danger col-12">
            {t('alert.due_date_passed')}
            <span className="font-weight-bold">
              {` ${Math.ceil(passed_date)} ${t('title.day')}`}.
            </span>
            {t('title.please_pay_bill')}
          </div>
        )
      } else if (today >= coming_date && coming_date < term_date) {
        const diffTime = Math.abs(new Date(term_date) - new Date())
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        alert = (
          <div className="alert alert-warning col-12">
            {t('alert.due_date_coming_soon')}{' '}
            <span className="font-weight-bold">{`${diffDays} ${t('title.day')}`}</span>.{' '}
            {`${t('alert.due_date_please_pay')} ${formatDate(
              row.payment_term_date,
              'DD-MM-YYYY',
            )}.`}
          </div>
        )
      }
    }
    if (alert) {
      return <div className="row m-1">{alert}</div>
    } else {
      return null
    }
  }
  */

  const CardFooter = (data) => {
    const row = data.data
    const currTime = moment()
    const createdOrderTime = moment(row.created_date)
    const configTime = moment(INVOICE_V2)

    const confirmationShippingStatus = async (e, data, type) => {
      e.preventDefault()
      const payload = {
        uid: data.uid,
        status: type,
      }
      const payloadUpdate =
        type === 'DELIVERED'
          ? {
              ...payload,
              shipping_date_delivered: currTime.format('YYYY-MM-DD HH:mm:ss'),
            }
          : {
              ...payload,
              updated_by: account.full_name,
            }
      const confirm = await confirmationAlert({
        title: t('title.are_you_sure'),
        message:
          type === 'DELIVERED'
            ? t('message.confirmation_delivered_shipped')
            : t('message.confirmation_delivered_cancelled'),
        icon: 'warning',
      })
      if (confirm) {
        type === 'DELIVERED'
          ? shippingHeaderApproval(payloadUpdate)
          : shippingHeaderCancel(payloadUpdate)
      }
    }

    function appendPrev(url, prevValue = 'confirmation-shipping') {
      const prefix = url.includes('?') ? '&' : '?'
      return `${url}${prefix}prev=${prevValue}`
    }

    return (
      <>
        <hr className="m-0" />
        {/* <AlertBill row={row} /> */}
        <div className="row overflow-auto">
          <div className="col-12 mt-2 mb-2 d-flex flex-column flex-md-row justify-content-center justify-content-md-end">
            <Link
              to={'#'}
              onClick={() => {
                window.location = appendPrev(`/order/view/${row.transaction_uid}`)
              }}
              className="d-inline btn btn-xs font-size-10 my-1 mx-1"
              style={{ background: '#396AFC' }}
            >
              <i className="fa fa-eye mr-2"></i>
              {t('button.view_order')}
            </Link>
            {moment(createdOrderTime).isAfter(configTime) && (
              <>
                {row.shipping_date_sent &&
                  (currTime.isAfter(moment(row.shipping_date_sent)) ||
                    currTime.isSame(moment(row.shipping_date_sent))) &&
                  row.initial_status === 'SHIPPED' && (
                    <button
                      type="button"
                      onClick={(e) => confirmationShippingStatus(e, row, 'DELIVERED')}
                      className="d-inline btn rounded-pill btn-success pointer btn-xs my-1 mx-1 font-size-10"
                    >
                      <i className="fa fa-check mr-1"></i> {t('button.received_order')}
                    </button>
                  )}
                {row.initial_status === 'SHIPPED' && (
                  <button
                    type="button"
                    onClick={(e) => confirmationShippingStatus(e, row, 'CANCELLED')}
                    className="d-inline btn rounded-pill btn-danger pointer btn-xs my-1 mx-1 font-size-10"
                  >
                    <i className="fa fa-times mr-1"></i> {t('button.cancelled')}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </>
    )
  }

  const renderStatus = (status) => {
    const base = 'badge rounded-pill px-3 py-1 fw-medium'
    switch (status) {
      case 'SHIPPED':
        return <span className={`${base} bg-warning text-dark`}>{t('status.bill.SHIPPED')}</span>
      case 'DELIVERED':
        return <span className={`${base} bg-success text-white`}>{t('status.bill.DELIVERED')}</span>
      case 'CANCELLED':
        return <span className={`${base} bg-danger text-white`}>{t('status.bill.CANCELLED')}</span>
      default:
        return (
          <span className={`${base} bg-secondary text-white`}>{t(`status.bill.${status}`)}</span>
        )
    }
  }

  const InformationTransaction = (data) => {
    const row = data.data
    return (
      <div className="row my-3 text-break">
        <div className="col-xs-12 col-md-3">
          <span className="d-inline-block p-2">
            <small>{t(`title.order_number`)}</small> <br />
            <strong>{row.transaction_code ?? '-'}</strong>
          </span>
        </div>
        <div className="col-xs-12 col-md-3">
          <div className="p-2">
            <small>{t(`title.shipping_date_sent`)}</small> <br />
            <strong>{row.shipping_date_sent !== '' ? row.shipping_date_sent : '-'}</strong>
          </div>
        </div>
        {row?.shipping_date_delivered && (
          <div className="col-xs-12 col-md-3">
            <div className="p-2">
              <small>{t(`title.shipping_date_delivered`)}</small> <br />
              <strong>
                {row.shipping_date_delivered !== '' ? row.shipping_date_delivered : '-'}
              </strong>
            </div>
          </div>
        )}
        <div className="col-xs-12 col-md-3">
          <div className="p-2">
            <small>{t(`title.status`)}</small>
            <br />
            {renderStatus(row.initial_status)}
          </div>
        </div>
        <div className="col-xs-12 col-md-12">
          <div className="p-2">
            <small>{t('title.note')}</small>
            <br />
            <strong>{row?.shipping_note ? row.shipping_note : '-'}</strong>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {/* FILTER */}
      <WideCardFilter
        filter={filter}
        payload={payload}
        handleFilter={handleFilter}
        label_input={t('placeholder.shipping_filter')}
        getData={getDataConfirmShipping}
        loading={loadingCSV}
      />
      {loading ? (
        <div className="d-flex justify-content-center">
          <Loading />
        </div>
      ) : (
        <>
          {datacard.items?.length > 0 ? (
            <>
              {datacard?.items?.map((row, key) => {
                return (
                  <div key={key}>
                    <div className="border border-width-2 border-color-3 borders-radius-6 container wide-card rounded mb-5">
                      <CardHeader data={row} />
                      <div className="row">
                        <div className="col-12">
                          <CardBody data={row} />
                        </div>
                      </div>
                      <CardFooter data={row} />
                    </div>
                  </div>
                )
              })}
              <Pagination
                data={datacard.pages}
                onChangePage={handlePageChange}
                onLimitChange={handleLimitChange}
              />
            </>
          ) : (
            <>
              <div className="d-flex justify-content-center">{t('message.data_not_found')}</div>
            </>
          )}
        </>
      )}
    </>
  )
}

export default WideCardConfirmationShipping
